// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Veritabanı kütüphanesini ekledik

const firebaseConfig = {
  apiKey: "AIzaSyB8oQ8eIOd1vuIzv1u2GsvmtSOxY2RKlNA",
  authDomain: "menucell-id.firebaseapp.com",
  projectId: "menucell-id",
  storageBucket: "menucell-id.firebasestorage.app",
  messagingSenderId: "610586798818",
  appId: "1:610586798818:web:3ef9cd013e896aa22e4cbb",
  measurementId: "G-G66YJ1ZPT4"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Veritabanını dışarıya açıyoruz ki diğer dosyalardan erişebilelim
export const db = getFirestore(app);